<div style="overflow-x: hidden">
  <div class="card-print" id="printSection">
    <div class="row no-print">
      <div class="col-md-12">
        <button
          class="btn btn-primary btn-sm"
          style="margin-top: 10px"
          (click)="printClick()"
        >
          Print
        </button>
        <button
          type="button"
          class="btn-close float-end"
          data-bs-dismiss="modal"
          aria-label="Close"
          style="margin-top: 10px"
          (click)="closeModalClick()"
        ></button>
      </div>
    </div>
    <div class="card-header">
      <div class="row">
        <div class="col-4">
          <p style="line-height: 1.25">
            <span style="font-weight: bold">{{
              sharedService.company_info.company_name
            }}</span
            ><br />
            <span style="font-weight: bold"
              >FFL: {{ sharedService.company_info.ffl }}</span
            >
          </p>
        </div>
        <div class="col-4">
          <h6 style="text-align: center; font-weight: bold">
            ACQUISITION AND DISPOSITION
          </h6>
          <h6 style="text-align: center; font-weight: bold">
            {{ sharedService.selected_boundbook.boundbook_name }}
          </h6>
        </div>
        <div class="col-4">
          <div class="float-end">
            <!-- date range -->
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <table
        class="table table-bordered table-sm sticky-table"
        style="font-size: 10px"
      >
        <colgroup>
          <col style="width: 50px" /> <!-- Firearm ID -->
          <col style="width: 150px" /> <!-- Manufacture / Importer -->
          <col style="width: 100px" /> <!-- Model -->
          <col style="width: 100px" /> <!-- Serial Number -->
          <col style="width: 100px" /> <!-- Type -->
          <col style="width: 150px" /> <!-- Caliber or Gauge -->
          <col style="width: 50px" /> <!-- Acquisition Date -->
          <col style="width: 150px" /> <!-- Name and address of nonlicensee -->
          <col style="width: 50px" /> <!-- Disposition Date -->
          <col style="width: 150px" /> <!-- Name -->
          <col style="width: 150px" /> <!-- Address of nonlicensee, FFL License #, Form 4473 Transaction # -->

        </colgroup>
        <thead>
          <!-- Top row: grouping headers -->
          <tr>
            <th colspan="8" style="text-align: center; font-size: 16px">
              ACQUISITION
            </th>
            <th colspan="3" style="text-align: center; font-size: 16px">
              DISPOSITION
            </th>
            <!-- optional – just to balance it visually -->
          </tr>

          <!-- Second row: individual column headers -->
          <tr>
            <th>Firearm ID</th>
            <th>Manufacture / Importer</th>
            <th>Model</th>
            <th>Serial Number</th>
            <th>Type</th>
            <th>Caliber or Gauge</th>
            <th>Date</th>
            <th>
              Name and address of nonlicensee <br />Licensee name and license
              No.
            </th>
            
            <th>Date</th>
            <th>Name</th>
            <th>
              Address of nonlicensee<br />license No. of licensee<br />Form 4473
              Transaction No.
            </th>
          </tr>
        </thead>
        <tbody>
          @for (entry of bound_book_entries; track entry) {
            <tr [class.has-modifications]="hasModificationEvents(entry)">
              <td>{{ entry.firearm_id }}</td>
              <td>{{ entry.a_manufacture }} / {{ entry.a_importer }}</td>
              <td>{{ entry.a_model }}</td>
              <td>{{ entry.a_serial_number }}</td>
              <td>{{ entry.a_firearm_type }}</td>
              <td>{{ entry.a_caliber_gauge }}</td>
              <td>{{ entry.a_date_acquired | date: "shortDate" }}</td>
              <td>
                @if (entry.a_business_name) {
                  {{ entry.a_business_name }}
                  <br />
                  {{ entry.a_ffl }}
                }
                @if (!entry.a_business_name && entry.a_received_from_name) {
                  {{ entry.a_received_from_name }}
                  <br />
                  {{ entry.a_ffl }}
                }
              </td>
              <td>{{ entry.d_date_disposed | date: "shortDate" }}</td>
              <td>
                @if (entry.d_disposed_to) {
                  {{ entry.d_disposed_to }}
                } @else if (entry.d_first_name) {
                  {{ entry.d_first_name }} {{ entry.d_last_name }}
                }
                @if (entry.d_business_name) {
                  <br />{{ entry.d_business_name }}
                }
              </td>
              <td>
                @if (entry.d_form4473_id) {
                  Form 4473 # {{ entry.d_form4473_id }}
                } @else if (entry.d_ffl) {
                  FFL# {{ entry.d_ffl }}
                }
              </td>
            </tr>
            <!-- Modification event sub-rows -->
            @if (hasModificationEvents(entry)) {
              @for (
                modEvent of getModificationEvents(entry);
                track modEvent.date_time_stamp;
                let i = $index;
                let count = $count
              ) {
                <tr class="modification-row">
                  <td
                    [style.border-bottom]="i < count - 1 ? 'hidden' : null"
                    style="border-right: none; border-left: hidden !important"
                  ></td>
                  <td
                    colspan="10"
                    style="
                      padding: 0 !important;
                      border: 1px solid #dee2e6 !important;
                    "
                  >
                    <div class="mod-container">
                      <div class="mod-index">
                        <div class="vertical-text">
                          Edit <br />
                          {{ i + 1 }} of {{ count }}
                        </div>
                      </div>
                      <div class="mod-details">
                        <strong>{{ modEvent.event }}</strong
                        ><br />
                        {{ modEvent.date_time_stamp | date: "short" }}
                      </div>
                      <div class="mod-changes">
                        <strong>Changes made:</strong>
                        @for (
                          change of getFormattedChanges(
                            modEvent.value_changed_from,
                            modEvent.value_changed_to
                          );
                          track change.key;
                          let cIndex = $index
                        ) {
                          <div style="margin-top: 2px">
                            {{ cIndex + 1 }}.
                            {{ change.key | titlecase }} modified from "{{
                              change.from
                            }}" to "{{ change.to }}"
                          </div>
                        }
                      </div>
                    </div>
                  </td>
                </tr>
              }
            }
          }
        </tbody>
      </table>
    </div>
    <!-- Footer for print -->
    <div class="print-footer">
      <div class="footer-left">
        Created by FFL XCEL on {{ currentDate | date: "short" }}
      </div>
      <div class="footer-right">Page <span class="page-number"></span></div>
    </div>
  </div>
</div>
